/* Christmas 2026 checker (25 Oct 2026). Data comes from #ss-xmas-data, written by snippets/ss-xmas.liquid. */
(function () {
  var node = document.getElementById('ss-xmas-data');
  var root = document.querySelector('[data-sjx]');
  if (!node || !root || root.dataset.sjxReady) return;
  root.dataset.sjxReady = '1';
  var D;
  try { D = JSON.parse(node.textContent); } catch (e) { return; }

  var AU = D.market === 'au';
  var mode = root.dataset.mode;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var $ = function (s) { return root.querySelector(s); };
  var set = function (s, t) { var el = $(s); if (el) el.textContent = t; };

  // All cut-offs are 11:59pm Sydney (AEDT) = 12:59 UTC the same day.
  function dec(day) { return Date.UTC(2026, 11, day, 12, 59) / 1000; }
  function label(t) { var d = new Date(t * 1000); return DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()]; }
  function short(t) { var d = new Date(t * 1000); return d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()].slice(0, 3); }
  function pct(t) { return Math.max(0, Math.min(100, (t - D.t0) / (D.t1 - D.t0) * 100)); }
  function left(t) {
    var s = t - Date.now() / 1000;
    if (s <= 0) return null;
    var d = Math.floor(s / 86400);
    if (d >= 2) return d + ' days left';
    var h = Math.floor(s / 3600);
    return h >= 2 ? h + ' hours left' : 'Less than 2 hours left';
  }

  var state = {from: 'NSW', to: 'NSW', remote: false};

  function orderBy() {
    if (state.remote || state.to === 'NT') return D.orderby.remote;
    if (state.to === 'WA') return D.orderby.wa;
    return D.orderby.main;
  }

  function parcelT() { var i = D.parcel.cols.indexOf(state.to); return dec(D.parcel[state.from][i]); }
  // Australia Post: Express 23 Dec between NSW, ACT, Vic, Qld, SA, Tas and within those states; 22 Dec to WA, to the NT
  // and from WA. Anything else touching WA or the NT is given the earlier date, which is the safe side.
  function expressT() { return (/^(WA|NT)$/.test(state.from) || /^(WA|NT)$/.test(state.to)) ? dec(22) : dec(23); }

  function render() {
    var ob = orderBy(), now = Date.now() / 1000, c = D.city[state.to];
    var open = left(ob.t);
    set('[data-sjx-ob]', open ? 'Order by ' + ob.label : 'Standard delivery for Christmas has closed');
    set('[data-sjx-count]', open || 'Closed');
    var ss = open
      ? 'We pack it by hand in Sydney and send it with Australia Post, ' + (c && !state.remote ? 'about ' + c[1] + ' business days after dispatch to ' + c[0] + '.' : 'usually 2 to 5 business days after dispatch to most addresses, longer for regional and remote areas.')
      : 'Express is available at checkout, but we can’t promise Christmas delivery now. Anything ordered today still arrives as a late surprise.';
    if (open && !AU) ss += ' It never goes through customs.';
    set('[data-sjx-ss-small]', ss);
    var tm = $('[data-sjx-obtime]'); if (tm) tm.hidden = !open;

    if (AU) {
      var p = parcelT(), x = expressT();
      set('[data-sjx-diy-big]', p > now ? 'Parcel Post by ' + label(p) : (x > now ? 'Parcel Post has closed' : 'Australia Post’s Christmas dates have passed'));
      set('[data-sjx-diy-small]', (x > now ? 'Express Post by ' + label(x) + '.' : 'Express Post has closed too.') + (state.remote ? ' These are metro dates, so post earlier for a regional address.' : ''));
    } else if (mode !== 'cards' && now > D.diy) {
      set('[data-sjx-diy-big]', 'The safe posting window has closed');
      set('[data-sjx-diy-small]', 'Royal Mail’s 2024 Tracked date was 7 December with online postage. A parcel posted from the UK now may not arrive for Christmas.');
    }

    var tl = $('[data-sjx-timeline]');
    if (tl) {
      tl.querySelector('.sjx-lanes').style.setProperty('--now', pct(now) + '%');
      var bar = function (k, t) {
        var b = tl.querySelector('[data-sjx-bar="' + k + '"]'); if (!b) return;
        b.style.width = pct(t) + '%';
        var e = b.querySelector('em'); if (e) e.textContent = short(t);
      };
      bar('ss', ob.t);
      if (AU) { bar('parcel', parcelT()); bar('express', expressT()); }
      // Before 1 Nov the today line sits on the axis start, so the start label says Today instead of overlapping it.
      var p0 = pct(now), td = tl.querySelector('[data-sjx-today]'), a0 = tl.querySelector('[data-sjx-axis0]');
      if (td) { td.style.left = p0 + '%'; td.hidden = p0 < 6 || p0 > 88; }
      if (a0) a0.textContent = p0 < 6 ? 'Today' : '1 Nov';
    }

    var g = $('[data-sjx-gcal]');
    if (g) g.href = gcal(ob);
  }

  function stamp(t) { return new Date(t * 1000).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
  var TITLE = AU ? 'Last day to order a Same Skies gift box for Christmas' : 'Last day to order a Same Skies box for Christmas';
  function details(ob) {
    var site = /^https?:/.test(location.origin) ? location.origin : (AU ? 'https://www.sameskies.com.au' : 'https://www.sameskies.co.uk');
    return 'Standard delivery for Christmas closes at 11:59pm Sydney time on ' + ob.label + (AU ? '.' : ' (12:59pm UK time).') + ' ' + site + (AU ? '/pages/christmas-gift-boxes' : '/pages/christmas-gifts-to-australia');
  }
  function gcal(ob) {
    return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(TITLE) +
      '&dates=' + stamp(ob.t - 3600) + '/' + stamp(ob.t) + '&details=' + encodeURIComponent(details(ob));
  }
  function ics(ob) {
    var L = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Same Skies//Christmas checker//EN', 'BEGIN:VEVENT',
      'UID:sjx-' + state.to + '-' + ob.t + '@sameskies', 'DTSTAMP:' + stamp(Date.now() / 1000), 'DTSTART:' + stamp(ob.t - 3600),
      'DTEND:' + stamp(ob.t), 'SUMMARY:' + TITLE, 'DESCRIPTION:' + details(ob).replace(/,/g, '\\,'),
      'BEGIN:VALARM', 'TRIGGER:-P3D', 'ACTION:DISPLAY', 'DESCRIPTION:Christmas order-by date in 3 days', 'END:VALARM',
      'END:VEVENT', 'END:VCALENDAR'];
    var url = URL.createObjectURL(new Blob([L.join('\r\n')], {type: 'text/calendar'}));
    var a = document.createElement('a'); a.href = url; a.download = 'same-skies-christmas.ics';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('input[type=radio]')) state.to = t.value;
    if (t.matches('[data-sjx-to]')) state.to = t.value;
    if (t.matches('[data-sjx-from]')) state.from = t.value;
    if (t.matches('[data-sjx-remote]')) state.remote = t.checked;
    render();
  });
  var ib = $('[data-sjx-ics]');
  if (ib) ib.addEventListener('click', function () { ics(orderBy()); });

  var form = $('[data-sjx-remind]');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var msg = form.querySelector('[data-sjx-msg]'), email = form.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = 'Check the email address and try again.'; return; }
    if (!form.consent.checked) { msg.textContent = 'Tick the box so we can send the reminder.'; return; }
    var ob = orderBy(), remind = new Date((ob.t - 3 * 86400) * 1000);
    var iso = function (d) { return d.toISOString().slice(0, 10); };
    var btn = form.querySelector('button'); btn.disabled = true; msg.textContent = 'Saving…';
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + D.company, {
      method: 'POST',
      headers: {'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15'},
      body: JSON.stringify({data: {type: 'subscription', attributes: {
        custom_source: 'Christmas checker ' + D.market.toUpperCase(),
        profile: {data: {type: 'profile', attributes: {email: email, properties: {
          ss_xmas_market: D.market, ss_xmas_state: state.to, ss_xmas_remote: state.remote,
          ss_xmas_orderby: iso(new Date(ob.t * 1000)), ss_xmas_remind_on: iso(remind)}}}}},
        relationships: {list: {data: {type: 'list', id: D.list}}}}})
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      msg.textContent = 'Done. We’ll email you on ' + DAYS[remind.getUTCDay()] + ' ' + remind.getUTCDate() + ' ' + MONTHS[remind.getUTCMonth()] + '.';
      form.email.value = '';
    }).catch(function () {
      btn.disabled = false;
      msg.textContent = 'That didn’t go through. Check the email address and try again.';
    });
  });

  render();
  setInterval(render, 60000);
})();
